import { render, staticRenderFns } from "./BasicCollpase.vue?vue&type=template&id=6c48de49"
import script from "./BasicCollpase.vue?vue&type=script&lang=js"
export * from "./BasicCollpase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports